import initReactApp from 'dpl/util/initReactApp';
import ContactQuiz from 'dpl/contacts/components/ContactQuiz';

initReactApp({ ContactQuiz });
